module.exports = __webpack_public_path__ + "img/creditcardlogo.f64daa3c.png";